import React, { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import FormInputText from '../../../common/Forms/FormTextField';
import { useForm, useWatch } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FormInputDropdown from '../../../common/Forms/FormDropdown';
import FormInputMultiCheckbox from '../../../common/Forms/FormCheckbox';
import {
  EPISODE_AUTHORIZATION_UPDATE_URL,
  EPISODE_CBP_AUTHORIZATION_PDF_URL,
  EPISODE_AUTHORIZATION_PDF_URL,
  fieldRequired,
  dateFormat2,
  formDateFormat,
  dateTimeFormat
} from '../../../../constants';
import { getAuthPdfForm } from '../../../../redux/episode/authTab/authPdfSlice';
import CbpAuthDialog from './CbpAuthTabDialog';
import MakeAdjustmentDialog from './MakeAdjustmentDialog';
import {
  DialogHeader,
  DialogHeading,
  ButtonWrapper,
  CancelButton,
  SaveButton,
  DeleteButton,
  DataGridContainer,
  GridContainer,
  NoteHeading,
  LeftGrid,
} from '../../Episode.Styled';
import {
  cbpAuthForm,
  newCbpAuthForm,
} from '../../../../redux/episode/authTab/cbpAuthFormSlice';
import { DialogDivider } from '../../../ui/styled';
import {
  setModality,
  setCommunityBasedProvider,
  setBudgetType,
  setAuthType,
  setFundingOrg,
  setTransferForm,
  setInitialReferral,
  setAthIssueDate,
  setExt1IssueDate,
  setExt2IssueDate,
  setAuthorizedByOriginal,
  setAuthorizedByExtension1,
  setAuthorizedByExtension2,
  setExt1StartDate,
  setExt2StartDate,
  setDaysAuthorisedQty,
  setExt1DayQty,
  setExt2DayQty,
  setDaysAuthorisedDayDelay,
  setExt1EndDate,
  setExt2EndDate,
  setOverAllStartDate,
  setOverallQty,
  setOverAllEndDate,
  setUnitsTotal,
  setMaxUnitsPerWeek,
  setMaxIndsPerWeek,
  setMaxGrpsPerWeek,
  setCbpAdmitDate,
  setCbpDischargeDate,
  setAuthStartDate,
  setAuthEndDate,
  setPlacementType,
  setRelapse,
  setAuthComment,
  setCompletionSurveyAdministered,
  setAuthIsLocked,
  setAdministrativeTransferAdmit,
  setAuthorizationReviewedBy,
  setReviewDate,
  setAthTPRcd,
  setAth1502Rcd
} from '../../../../redux/episode/authTab/authFormSlice';
import { postStopApi, setStopApi, deleteStopApi } from '../../../../services/StopApi/StopApi';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import FormSuccess from '../../../common/Forms/FormSuccess';
import { getCbpAuthPdfForm } from '../../../../redux/episode/authTab/cbpAuthPdfSlice';
import AuthPdfDialog from './AuthPdfDialog';
import {
  resetAuthPdfForm,
  setAuthPdfPrint,
} from '../../../../redux/episode/authTab/authPdfSlice';
import { getContactByUser } from '../../../Contact/services/contactsApi';
import CalOMSAdmit from './CalOMS/CalOMSAdmit';
import CalOMSDischarge from './CalOMS/CalOMSDischarge';
import EpisodeHeader from '../EpisodeHeader'

const schema = yup.object().shape({
  modality: yup.string().required(fieldRequired),
  communityBasedProvider: yup.string().required(fieldRequired),
  placementType: yup.string().required(fieldRequired),
  //fundingOrg: yup.string().required(fieldRequired),
  authorizedByOriginal: yup.string().required(fieldRequired),
  authStartDate: yup.date().typeError(fieldRequired).required(),
  daysAuthorisedQty: yup.string().required(fieldRequired),
  authComment: yup
    .string()
    .nullable()
    .max(256, 'This field should not exceed 256 characters'),
});

const AuthDialog = (props) => {
  const {
    open,
    setOpen,
    authData,
    cbpData,
    treatments,
    authToken,
    fetchAuthList,
    fetchAuth,
    //fetchAuthRow,
    openBackdrop,
    episodeReferralSource,
    episodeHeaderData
  } = props;

  //console.log('### episodeHeaderData');
  //console.log(episodeHeaderData);
  //const [doSubmit, setDoSubmit] = useState(false);
  const [currentModality, setCurrentModality] = useState(null);
  const [user, setUser] = useState(null);
  useEffect(() => {
    if (open) {
      if (user?.signInUserSession.accessToken.jwtToken) {
        fetchAuthList();
      }
    }
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then(function (user) {
        getContactByUser(user)
          .then(function (loggedInContact) {
            user.contact = loggedInContact;
          })
          .catch(() => console.log('Not signed in'));
        //console.log(user)
        return user;
      })
      .catch(() => console.log('Not signed in'));
  };

  const dispatch = useDispatch();

  const [openMakeAdjutmentDialog, setOpenMakeAdjutmentDialog] = useState(false);
  const [openCbpAuthDialog, setOpenCbpAuthDialog] = useState(false);
  const [openCbpBackdrop, setOpenCbpBackdrop] = useState(false);
  const [openAuthPdfDialog, setOpenAuthPdfDialog] = useState(false);
  const [openAuthPdfBackdrop, setOpenAuthPdfBackDrop] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);
  const [isNewAuthForm, setIsNewAuthForm] = useState(false);
  const [isCalOMSAdmitForm, setIsCalOMSAdmitForm] = useState(false);
  const [isCalOMSDischargeForm, setIsCalOMSDischargeForm] = useState(false);

  const authForm = useSelector((state) => state?.authForm);

  const authReferenceData = useSelector((state) => state?.authReferenceData);
  const [filterProviderList, setFilterProviderList] = useState(
    authReferenceData?.communityBasedProviderList
  );
  const authPdfForm = useSelector((state) => state?.authPdfForm);
  const participantInfo = useSelector(
    (state) => state?.participants?.participantsDetail
  );
  //console.log('participantInfo');
  //console.log(participantInfo);

  //console.log('### AUTH FORM')
  //console.log(authForm)

const defaultValue = {
  authId: authForm?.authId,
  modality: authForm?.modality ? authForm?.modality?.value : '',
  communityBasedProvider: authForm?.communityBasedProvider
    ? authForm?.communityBasedProvider?.value
    : '',
  //authType: authForm?.authType?.athTypId,
  authType: episodeReferralSource?.startsWith('NSG')
    ? 'Non-Sap/Parole Referral'
    : 'SAP Referral',
  budgetType: authForm?.newAuthForm
    ? authForm?.budgetType
    : authForm?.budgetType?.budTypeId,
  fundingOrg: authReferenceData?.fundingOrganizationList[0].value,
  transferForm: authForm?.transferForm?.value,
  initialReferral: authForm?.initialReferral?.value,
  athIssueDate: moment(
    authForm?.athIssueDate ? authForm?.athIssueDate : new Date()
  ).format(formDateFormat),
  authorizedByOriginal: authForm?.authorizedByOriginal
    ? authForm?.authorizedByOriginal?.value
    : '',
  authStartDate: authForm?.authStartDate
    ? moment(authForm?.authStartDate).format(formDateFormat)
    : null,
  daysAuthorisedQty: authForm?.daysAuthorisedQty,
  daysAuthorisedDayDelay: authForm?.daysAuthorisedDayDelay,
  daysAuthorisedEndDate: authForm?.daysAuthorisedEndDate
    ? moment(authForm?.daysAuthorisedEndDate).format(formDateFormat)
    : null,
  authEndDate: authForm?.authEndDate
    ? moment(authForm?.authEndDate).format(formDateFormat)
    : null,
  ext1IssueDate: authForm?.ext1IssueDate
    ? moment(authForm?.ext1IssueDate).format(formDateFormat)
    : null,
  authorizedByExtension1: authForm?.authorizedByExtension1?.value,
  ext1StartDate: authForm?.ext1StartDate
    ? moment(authForm?.ext1StartDate).format(formDateFormat)
    : null,
  ext1DayQty: authForm?.ext1DayQty,
  ext1EndDate: authForm?.ext1EndDate
    ? moment(authForm?.ext1EndDate).format(formDateFormat)
    : null,
  ext2IssueDate: authForm?.ext2IssueDate
    ? moment(authForm?.ext2IssueDate).format(formDateFormat)
    : null,
  authorizedByExtension2: authForm?.authorizedByExtension2?.value,
  ext2StartDate: authForm?.ext2StartDate
    ? moment(authForm?.ext2StartDate).format(formDateFormat)
    : null,
  ext2DayQty: authForm?.ext2DayQty,
  ext2EndDate: authForm?.ext2EndDate
    ? moment(authForm?.ext2EndDate).format(formDateFormat)
    : null,
  overAllStartDate: authForm?.overAllStartDate
    ? moment(authForm?.overAllStartDate).format(formDateFormat)
    : null,
  overallQty: authForm?.overallQty,
  overAllEndDate: authForm?.overAllEndDate
    ? moment(authForm?.overAllEndDate).format(formDateFormat)
    : null,
  unitsTotal: authForm?.unitsTotal,
  maxUnitsPerWeek: authForm?.maxUnitsPerWeek,
  maxIndsPerWeek: authForm?.maxIndsPerWeek,
  maxGrpsPerWeek: authForm?.maxGrpsPerWeek,
  cbpAdmitDate: authForm?.cbpAdmitDate
    ? moment(authForm?.cbpAdmitDate).format(formDateFormat)
    : null,
  cbpDischargeDate: authForm?.cbpDischargeDate 
    ? moment(authForm?.cbpDischargeDate).format(formDateFormat)
    : null,
  placementType: authForm?.placementType?.value
    ? authForm?.placementType?.value
    : '',
  relapse: authForm?.relapse?.value,
  authComment: authForm?.authComment,
  completionSurveyAdministered: authForm?.completionSurveyAdministered
    ? true
    : false,
  authIsLocked: authForm?.authIsLocked ? true : false,
  administrativeTransferAdmit: authForm?.administrativeTransferAdmit?.value,
  authorizationReviewedBy: authForm?.authorizationReviewedBy
    ? authForm?.authorizationReviewedBy?.value
    : '',
  reviewDate: authForm?.reviewDate
    ? moment(authForm?.reviewDate).format(formDateFormat)
    : null,
  athTPRcd: authForm?.athTPRcd
    ? moment(authForm?.athTPRcd).format(formDateFormat)
    : null,
  ath1502Rcd: authForm?.ath1502Rcd
    ? moment(authForm?.ath1502Rcd).format(formDateFormat)
    : null,
};

//console.log('### authForm')
//console.log(authForm)

const useFunction = useForm({
  mode: 'onChange',
  defaultValues: defaultValue,
  resolver: yupResolver(schema),
});
const { handleSubmit, reset, control, setValue, watch, register, formState } =
  useFunction;
const { isValid, dirtyFields, errors } = formState;

useEffect(() => {
  if (open) {
    //console.log('### RESET WITH');
    //console.log(defaultValue);
    reset(defaultValue);
  }
}, [
  defaultValue.authId,
  defaultValue.modality,
  defaultValue.communityBasedProvider,
  defaultValue.authType,
  defaultValue.budgetType,
  defaultValue.fundingOrg,
  defaultValue.transferForm,
  defaultValue.initialReferral,
  defaultValue.athIssueDate,
  defaultValue.authorizedByOriginal,
  defaultValue.authStartDate,
  defaultValue.daysAuthorisedQty,
  defaultValue.daysAuthorisedDayDelay,
  defaultValue.daysAuthorisedEndDate,
  defaultValue.authEndDate,
  defaultValue.ext1IssueDate,
  defaultValue.authorizedByExtension1,
  defaultValue.ext1StartDate,
  defaultValue.ext1DayQty,
  defaultValue.ext1EndDate,
  defaultValue.ext2IssueDate,
  defaultValue.authorizedByExtension2,
  defaultValue.ext2StartDate,
  defaultValue.ext2DayQty,
  defaultValue.ext2EndDate,
  defaultValue.overAllStartDate,
  defaultValue.overallQty,
  defaultValue.overAllEndDate,
  defaultValue.unitsTotal,
  defaultValue.maxUnitsPerWeek,
  defaultValue.maxIndsPerWeek,
  defaultValue.maxGrpsPerWeek,
  defaultValue.cbpAdmitDate,
  defaultValue.cbpDischargeDate,
  defaultValue.placementType,
  defaultValue.relapse,
  defaultValue.authComment,
  defaultValue.completionSurveyAdministered,
  defaultValue.authIsLocked,
  defaultValue.administrativeTransferAdmit,
  defaultValue.authorizationReviewedBy,
  defaultValue.reviewDate,
  defaultValue.athTPRcd,
  defaultValue.ath1502Rcd
]);

const daysAuthorisedQty = useWatch({
  control,
  name: 'daysAuthorisedQty',
});

const modality = useWatch({
  control,
  name: 'modality',
});

//console.log('### authReferenceData?.modalityList')
//console.log(authReferenceData?.modalityList)
//console.log('### modality')
//console.log(modality)

const modalityId = authReferenceData?.modalityList.filter((item) =>
  item.modDsc === modality ? item.modId : ''
);
const modalityValues = {
  id: modalityId ? modalityId[0]?.modId : null,
  value: modalityId ? modalityId[0]?.modDsc : null,
  isResidential: modalityId ? modalityId[0]?.modResYN : null,
};
const originalModalityValues = modalityValues;
//console.log('##### modalityValues')
//console.log(modalityValues)

const communityBasedProvider = useWatch({
  control,
  name: 'communityBasedProvider',
});

//console.log('### authReferenceData?.communityBasedProviderList')
//console.log(authReferenceData?.communityBasedProviderList)
//console.log('### filterProviderList')
//console.log(filterProviderList)
//console.log('### communityBasedProvider')
//console.log(communityBasedProvider)

const communityBasedProviderId =
  authReferenceData?.communityBasedProviderList.filter((item) =>
    item.value === communityBasedProvider ? item.id : ''
  );
const communityBasedProviderValues = {
  id: communityBasedProviderId ? communityBasedProviderId[0]?.id : null,
  value: communityBasedProviderId ? communityBasedProviderId[0]?.value : null,
};
const originalCommunityBasedProviderValues = communityBasedProviderValues;
//console.log('##### originalCommunityBasedProviderValues')
//console.log(originalCommunityBasedProviderValues)
const authType = useWatch({
  control,
  name: 'authType',
});
const authTypeId = authReferenceData?.authTypeList?.filter((item) =>
  item.athTypId === authType ? item.athTypId : ''
);
const authTypeValues = {
  athTypId: authTypeId ? authTypeId[0]?.athTypId : null,
};

const fundingOrg = useWatch({
  control,
  name: 'fundingOrg',
});
const fundingOrgId = authReferenceData?.fundingOrganizationList.filter((item) =>
  item.value === fundingOrg ? item.id : ''
);
const fundingOrgValues = {
  id: fundingOrgId ? fundingOrgId[0]?.id : null,
  value: fundingOrgId ? fundingOrgId[0]?.value : null,
};

const transferForm = useWatch({
  control,
  name: 'transferForm',
});
const transferFormId = authReferenceData?.transferFormList.filter((item) =>
  item.value === transferForm ? item.id : ''
);
const transferFormValues = {
  id: transferFormId ? transferFormId[0]?.id : null,
  value: transferFormId ? transferFormId[0]?.value : null,
};

const initialReferral = useWatch({
  control,
  name: 'initialReferral',
});
const initialReferralId = authReferenceData?.initialReferralList.filter(
  (item) => (item.value === initialReferral ? item.id : '')
);
const initialReferralValues = {
  id: initialReferralId ? initialReferralId[0]?.id : null,
  value: initialReferralId ? initialReferralId[0]?.value : null,
};

const authorizedByOriginal = useWatch({
  control,
  name: 'authorizedByOriginal',
});
const authorizedByOriginalId = authReferenceData?.authorizedByOriginal.filter(
  (item) => (item.value === authorizedByOriginal ? item.id : '')
);
const authorizedByOriginalValues = {
  id: authorizedByOriginalId ? authorizedByOriginalId[0]?.id : null,
  value: authorizedByOriginalId ? authorizedByOriginalId[0]?.value : null,
};

const authorizedByExtension1 = useWatch({
  control,
  name: 'authorizedByExtension1',
});
const authorizedByExtension1Id =
  authReferenceData?.authorizedByExtension1.filter((item) =>
    item.value === authorizedByExtension1 ? item.id : ''
  );
const authorizedByExtension1Values = {
  id: authorizedByExtension1Id ? authorizedByExtension1Id[0]?.id : null,
  value: authorizedByExtension1Id ? authorizedByExtension1Id[0]?.value : null,
};

const authorizedByExtension2 = useWatch({
  control,
  name: 'authorizedByExtension2',
});
const authorizedByExtension2Id =
  authReferenceData?.authorizedByExtension2.filter((item) =>
    item.value === authorizedByExtension2 ? item.id : ''
  );
const authorizedByExtension2Values = {
  id: authorizedByExtension2Id ? authorizedByExtension2Id[0]?.id : null,
  value: authorizedByExtension2Id ? authorizedByExtension2Id[0]?.value : null,
};

const placementType = useWatch({
  control,
  name: 'placementType',
});
const placementTypeId = authReferenceData?.placementTypeList.filter((item) =>
  item.value === placementType ? item.id : ''
);
const placementTypeValues = {
  id: placementTypeId ? placementTypeId[0]?.id : null,
  value: placementTypeId ? placementTypeId[0]?.value : null,
};

const relapse = useWatch({
  control,
  name: 'relapse',
});
const relapseId = authReferenceData?.relapseList.filter((item) =>
  item.value === relapse ? item.id : ''
);
const relapseValues = {
  id: relapseId ? relapseId[0]?.id : null,
  value: relapseId ? relapseId[0]?.value : null,
};

const administrativeTransferAdmit = useWatch({
  control,
  name: 'administrativeTransferAdmit',
});
const administrativeTransferAdmitId =
  authReferenceData?.admTransferAdmitList.filter((item) =>
    item.value === administrativeTransferAdmit ? item.id : ''
  );
const administrativeTransferAdmitValues = {
  id: administrativeTransferAdmitId
    ? administrativeTransferAdmitId[0]?.id
    : null,
  value: administrativeTransferAdmitId
    ? administrativeTransferAdmitId[0]?.value
    : null,
};

const authorizationReviewedBy = useWatch({
  control,
  name: 'authorizationReviewedBy',
});

const athTPRcd = useWatch({
  control,
  name: 'athTPRcd',
});

const ath1502Rcd = useWatch({
  control,
  name: 'ath1502Rcd',
});

//console.log('### REVIEWD BY');
//console.log(authorizationReviewedBy);
const authorizationReviewedById = authReferenceData?.authReviewedByList.filter(
  (item) => (item.value === authorizationReviewedBy ? item.id : '')
);
const authorizationReviewedByValues = {
  id: authorizationReviewedById ? authorizationReviewedById[0]?.id : null,
  value: authorizationReviewedById ? authorizationReviewedById[0]?.value : null,
};

useEffect(() => {
  if (open) {
    const mod = authReferenceData?.modalityList.filter(
      (m) => m.modDsc == modality
    );

    const residentialModalities = authReferenceData?.modalityList.filter(
      (a) => a.modResYN == true
    );
    const residentialModalitieIds = residentialModalities?.map(function (item) {
      return item.modId;
    });
    const residentialAuth = authData?.data.find(
      (a) =>
        a.authId != defaultValue.authId &&
        residentialModalitieIds?.includes(a.cboModId) &&
        (a.cbpDischargeDate == null || a.cbpDischargeDate == '-')
    );
    //console.log('### RES MODALITIES');
    //console.log(residentialModalitieIds);
    //console.log('### residentialAuth');
    //console.log(residentialAuth);

    const outpatientModalities = authReferenceData?.modalityList.filter(
      (a) => a.modResYN == false
    );
    const outpatientModalitieIds = outpatientModalities?.map(function (item) {
      return item.modId;
    });
    const outpatientAuth = authData?.data.find(
      (a) =>
        a.authId != defaultValue.authId &&
        outpatientModalitieIds?.includes(a.cboModId) &&
        (a.cbpDischargeDate == null || a.cbpDischargeDate == '-')
    );
    //console.log('### OTP MODALITIES');
    //console.log(outpatientModalitieIds);
    //console.log('### outpatientAuth');
    //console.log(outpatientAuth);

    const authStartDate = new Date(
      moment(defaultValue.authStartDate).format(formDateFormat)
    );
    //console.log('### defaultValue.authStartDate');
    //console.log(defaultValue.authStartDate);
    //console.log('### authStartDate');
    //console.log(authStartDate);

    const otpStartDate = new Date(
      moment(outpatientAuth?.authStartDate).format(formDateFormat)
    );
    //console.log('### outpatientAuth?.authStartDate');
    //console.log(outpatientAuth?.authStartDate);
    //console.log('### otpStartDate');
    //console.log(otpStartDate);

    const resStartDate = new Date(
      moment(residentialAuth?.authStartDate).format(formDateFormat)
    );

    const authEndDate = new Date(
      moment(defaultValue.authEndDate).format(formDateFormat)
    );

    const authOverallEndDate = new Date(
      moment(new Date(defaultValue.overAllEndDate) + defaultValue.daysAuthorisedDayDelay ?? 0).format(formDateFormat)
    );

    //console.log('### defaultValue.authEndDate');
    //console.log(defaultValue.authEndDate);
    //console.log('### authEndDate');
    //console.log(authEndDate);

    const otpOverAllEndDate = new Date(
      moment(outpatientAuth?.overAllEndDate).format(formDateFormat)
    );
    //console.log('### outpatientAuth?.overAllEndDate');
    //console.log(outpatientAuth?.overAllEndDate);
    //console.log('### otpOverAllEndDate');
    //console.log(otpOverAllEndDate);

    const overAllEndDate = moment(residentialAuth?.overAllEndDate);
    const resOverAllEndDate = new Date(overAllEndDate.format(formDateFormat));
    const resEndDate = new Date(
      overAllEndDate.subtract(1, 'days').format(formDateFormat)
    );

    if (!defaultValue.cbpDischargeDate && mod && mod.length) {
      const modId = mod[0].modId;
      //console.log(modId)
      if (modId === 'SLE' && !communityBasedProvider?.includes('RHWH')) {
        if (!outpatientAuth) {
          alert('SLE Requires Current Outpatient Auth or RHWH provider selected');
          if (!user?.contact?.authLock && !defaultValue.authIsLocked && currentModality) {
            defaultValue.modality = currentModality;
            reset(defaultValue);
            dispatch(setModality(currentModality));
          }
        } else {
          if (authStartDate && !moment(authStartDate).format().startsWith("0") && authEndDate && !moment(authEndDate).format().startsWith("0")) {
            //console.log('### authStartDate');
            //console.log(moment(authStartDate).format().startsWith("0"));
            //console.log('### authEndDate');
            //console.log(authEndDate);
            if (authStartDate < otpStartDate || authEndDate > otpOverAllEndDate) {
              alert(
                'SLE start and end dates cannot be outside Outpatient start and end dates'
              );
              if (!user?.contact?.authLock && !defaultValue.authIsLocked) dispatch(setAuthStartDate(''));
              //dispatch(setDaysAuthorisedQty(''));
              if (!user?.contact?.authLock && !defaultValue.authIsLocked) dispatch(setAuthEndDate(''));
            }
            if (
              residentialAuth &&
              residentialAuth.cboModId === 'SLE' &&
              authStartDate < resOverAllEndDate
            ) {
              alert(
                'SLE auth start date cannot be before existing SLE auth overall end date'
              );
              if (!user?.contact?.authLock && !defaultValue.authIsLocked) dispatch(setAuthStartDate(''));
              //dispatch(setDaysAuthorisedQty(''));
              if (!user?.contact?.authLock && !defaultValue.authIsLocked) dispatch(setAuthEndDate(''));
            }
          }
        }
      }

      if (
        !defaultValue.cbpDischargeDate &&
        modId !== 'SLE' &&
        modId !== 'SWC' &&
        modId !== 'O-OPT'
      ) {
        let didAlert = false;
        if (outpatientAuth) {
          if (
            (authStartDate > otpStartDate && authStartDate < otpOverAllEndDate) ||
            //(authEndDate >= otpStartDate && authEndDate < otpOverAllEndDate)
            (authOverallEndDate >= otpStartDate && authOverallEndDate < otpOverAllEndDate)
          ) {
            alert(
              'This authorization is overlapping an existing outpatient auth'
            );
            if (!user?.contact?.authLock && !defaultValue.authIsLocked) dispatch(setAuthStartDate(''));
            //dispatch(setDaysAuthorisedQty(''));
            if (!user?.contact?.authLock && !defaultValue.authIsLocked) dispatch(setAuthEndDate(''));
            didAlert = true;
          }
        }
        if (!didAlert && residentialAuth) {
          //alert(authStartDate)
          //alert(resEndDate)
          if (
            (authStartDate.getTime() != resStartDate.getTime()) &&
            ((authStartDate > resStartDate && authStartDate < resOverAllEndDate) ||
            (authEndDate >= resStartDate && authEndDate < resEndDate)))
           {
            alert(
              'This authorization is overlapping an existing residential or sober living auth'
            );
            //if (!window.confirm('Extend auth?')) {
              if (!user?.contact?.authLock && !defaultValue.authIsLocked) dispatch(setAuthStartDate(''));
              //dispatch(setDaysAuthorisedQty(''));
              if (!user?.contact?.authLock && !defaultValue.authIsLocked) dispatch(setAuthEndDate(''));
            //}
          }
        }
      }
    }
  }
}, [
  modality,
  defaultValue.authStartDate,
  //defaultValue.daysAuthorisedQty,
  defaultValue.authEndDate,
]);

useEffect(() => {
  if (open) {
    setCurrentModality(modality);

    const mod = authReferenceData?.modalityList.filter(
      (m) => m.modDsc == modality
    );
    if (mod && mod.length) {
      const modId = mod[0].modId;
      setFilterProviderList(
        authReferenceData?.communityBasedProviderList.filter((c) =>
          c?.value?.includes(modId)
        )
      );

      const residentialModalities = authReferenceData?.modalityList.filter(
        (a) => a.modResYN == true
      );
      const residentialModalitieIds = residentialModalities?.map(function (item) {
        return item.modId;
      });
      const residentialAuth = authData?.data.find(
        (a) =>
          a.authId != defaultValue.authId &&
          residentialModalitieIds?.includes(a.cboModId) &&
          (a.cbpDischargeDate == null || a.cbpDischargeDate == '-')
      );

      if (
        residentialAuth &&
        residentialAuth?.cboModId === 'SLE' &&
        currentModality &&
        modality &&
        currentModality !== modality
      ) {
        alert(
          'There is an existing sober living auth which required a concurrent outpatient auth'
        );
        if (!user?.contact?.authLock && !defaultValue.authIsLocked && currentModality)
          dispatch(setModality(currentModality));
      }
    }
  }
}, [modality]);

//console.log('### communityBasedProvider')
//console.log(communityBasedProvider)
useEffect(() => {
  if (open) {
    if (
      participantInfo?.length === 1 &&
      !participantInfo[0].registration290 &&
      communityBasedProvider?.includes('/290')
    ) {
      alert('Warning: Participant is not flagged 290');
      defaultValue.communityBasedProvider = '';
      reset(defaultValue);
      //console.log('### set communityBasedProviderValues with')
      //console.log('')
      //dispatch(setCommunityBasedProvider(''));
    } else if (
      participantInfo?.length === 1 &&
      participantInfo[0].registration290 &&
      communityBasedProvider &&
      !communityBasedProvider?.includes('/290')
    ) {
      alert('Provider is not flagged 290');
      if (!defaultValue.authIsLocked) defaultValue.communityBasedProvider = '';
      reset(defaultValue);
      //console.log('### set communityBasedProviderValues with')
      //console.log('')
      //dispatch(setCommunityBasedProvider(''));
    } 
    else {
      if (communityBasedProviderValues?.id) {
        //console.log('### set communityBasedProviderValues with')
        //console.log(communityBasedProviderValues)
        dispatch(setCommunityBasedProvider(communityBasedProviderValues));
      }
    }
  }
}, [communityBasedProvider]);

useEffect(() => {
  if (open) {
    if (modalityValues?.id) {
      dispatch(setModality(modalityValues));
    }
    if (authTypeValues?.athTypId) {
      dispatch(setAuthType(authTypeValues));
    }
    if (fundingOrgValues?.id) {
      dispatch(setFundingOrg(fundingOrgValues));
    }
    if (transferFormValues?.id) {
      dispatch(setTransferForm(transferFormValues));
    }
    if (initialReferralValues?.id) {
      dispatch(setInitialReferral(initialReferralValues));
    }
    if (authorizedByOriginalValues?.id) {
      dispatch(setAuthorizedByOriginal(authorizedByOriginalValues));
    }

    //dispatch(setAuthorizedByExtension1(authorizedByExtension1Values));
    //dispatch(setAuthorizedByExtension2(authorizedByExtension2Values));

    if (placementTypeValues?.id) {
      dispatch(setPlacementType(placementTypeValues));
    }
    if (relapseValues?.id) {
      dispatch(setRelapse(relapseValues));
    }
    if (administrativeTransferAdmitValues?.id) {
      dispatch(setAdministrativeTransferAdmit(administrativeTransferAdmitValues));
    }
    if (authorizationReviewedByValues?.id) {
      dispatch(setAuthorizationReviewedBy(authorizationReviewedByValues));
    }
  }
}, [
  //modality,
  communityBasedProvider,
  authType,
  fundingOrg,
  transferForm,
  initialReferral,
  authorizedByOriginal,
  //authorizedByExtension1,
  //authorizedByExtension2,
  placementType,
  relapse,
  administrativeTransferAdmit,
  authorizationReviewedBy,
  daysAuthorisedQty,
]);

// Removed redundant useEffects for athTPRcd and ath1502Rcd
// These values are already dispatched via onChange handlers in the register calls (lines 2007-2022)

const cbpAuthRowClick = (rowData) => {
  if (defaultValue.authIsLocked) {
    const commonParams = `${EPISODE_CBP_AUTHORIZATION_PDF_URL}/${rowData.cboAthId}`;
    const authorization = authToken;
    const cbpAuthDetail = {
      cboAthId: rowData.cboAthId,
      dayQuantity: rowData.dayQuantity,
      authStartDate: rowData.authStartDate,
      authEndDate: rowData.authEndDate,
    };
    dispatch(getCbpAuthPdfForm({ commonParams, authorization }));
    dispatch(cbpAuthForm(cbpAuthDetail));
    setOpenCbpBackdrop(true);
    setTimeout(() => {
      setOpenCbpBackdrop(false);
    }, 500);
    setOpenCbpAuthDialog(true);
  }
};

const handleClose = () => {
  setOpen(false);
  dispatch(setModality(''));
  dispatch(setCommunityBasedProvider(''));
  reset(defaultValue);
  dispatch(resetAuthPdfForm());
  setCurrentModality(null);
};

//const handleDelete = () => {
//  handleClose();
//}

const handleDelete = () => {
  const authId = authForm?.authId;
  const url = `${EPISODE_AUTHORIZATION_UPDATE_URL}/${authId}`;
  const authorization = authToken;
  const payload = {};
  deleteStopApi({ url, payload, authorization }).then((response) => {
    if (response.succeeded === true) {
      fetchAuthList();
      handleClose();
    }
  }).catch((e) => alert(e));
};

const handlePrintAuth = () => {
  onSubmit(false);

  setOpenAuthPdfBackDrop(true);
  setOpenAuthPdfDialog(true);
  if (authPdfForm?.succeeded) {
    setOpenAuthPdfBackDrop(false);
    setTimeout(() => {
      dispatch(setAuthPdfPrint(true));
    }, 1000);
  }
};

// useEffect(() => {
//   if (doSubmit) {
//     setDoSubmit(false);
//     submit();
//   }  
// }, [doSubmit]); 

// const onSubmit = () => {
//   setDoSubmit(true);
// }

const onSubmit = async (close = true) => {
  //if (!isSubmitting) {
      try {
        //setIsSubmitting(true);
        const url = `${EPISODE_AUTHORIZATION_UPDATE_URL}`;
        const authorization = authToken;
        if (authForm?.newAuthForm === true) {
          const payload = {
            authId: 0,
            athIssueDate: authForm?.athIssueDate ? authForm?.athIssueDate : null,
            athTPRcd: authForm?.athTPRcd ? authForm?.athTPRcd : null,
            ath1502Rcd: authForm?.ath1502Rcd ? authForm?.ath1502Rcd : null,
            reviewDate: authForm?.reviewDate ? authForm?.reviewDate : null,
            authStartDate: authForm?.authStartDate ? authForm?.authStartDate : null,
            authEndDate:
              moment(authForm?.authEndDate).format(formDateFormat) === 'Invalid date'
                ? null
                : moment(authForm?.authEndDate).format(formDateFormat),
            CBPID: authForm?.communityBasedProvider?.id
              ? authForm?.communityBasedProvider?.id
              : null,
            modality: authForm?.modality?.id,
            budgetTypeId: 'STOP',
            authType: authForm?.authType?.athTypId
              ? authForm?.authType?.athTypId
              : null,
            fundingOrgId: authForm?.fundingOrg?.id ? authForm?.fundingOrg?.id : null,
            transferFormId: authForm?.transferForm?.id
              ? authForm?.transferForm?.id
              : null,
            initialReferralId: authForm?.initialReferral?.id
              ? authForm?.initialReferral?.id
              : null,
            authorizedByOriginalId: authForm?.authorizedByOriginal?.id
              ? authForm?.authorizedByOriginal?.id
              : null,
            authorizedByExtension1Id: authForm?.authorizedByExtension1?.id
              ? authForm?.authorizedByExtension1?.id
              : null,
            authorizedByExtension2Id: authForm?.authorizedByExtension2?.id
              ? authForm?.authorizedByExtension2?.id
              : null,
            placementTypeId: authForm?.placementType?.id
              ? authForm?.placementType?.id
              : null,
            relapse: authForm?.relapse?.id ? authForm?.relapse?.id.toString() : null,
            administrativeTransferAdmitId: authForm?.administrativeTransferAdmit?.id
              ? authForm?.administrativeTransferAdmit?.id
              : null,
            authorizationReviewedBy: authForm?.authorizationReviewedBy?.id
              ? authForm?.authorizationReviewedBy?.id
              : null,
            cbpAuthEdited: user.contact.cntId,
            authEditDate: moment.utc().local().format("YYYY-MM-DDTHH:mm:ss"),
            authorizationCreatedBy: user.contact.cntId,
            authorizationCreatedDate: moment.utc().local().format("YYYY-MM-DDTHH:mm:ss"),
            completionSurveyAdministered: authForm?.completionSurveyAdministered
              ? authForm?.completionSurveyAdministered
              : false,
            authIsLocked: authForm?.authIsLocked ? authForm?.authIsLocked : false,
            unitsTotal: authForm?.unitsTotal ? authForm?.unitsTotal : null,
            authComment: authForm?.authComment ? authForm?.authComment : null,
            overallQty: authForm?.overallQty,
            overAllEndDate:
              moment(authForm?.overAllEndDate).format(formDateFormat) ===
              'Invalid date'
                ? null
                : moment(authForm?.overAllEndDate).format(formDateFormat),
            cbpAdmitDate: authForm?.cbpAdmitDate ? authForm?.cbpAdmitDate : null,
            cbpDischargeDate: authForm?.cbpDischargeDate
              ? authForm?.cbpDischargeDate
              : null,
            maxUnitsPerWeek: authForm?.maxUnitsPerWeek
              ? authForm?.maxUnitsPerWeek
              : null,
            maxIndsPerWeek: authForm?.maxIndsPerWeek
              ? authForm?.maxIndsPerWeek
              : null,
            maxGrpsPerWeek: authForm?.maxGrpsPerWeek
              ? authForm?.maxGrpsPerWeek
              : null,
            daysAuthorisedQty: authForm?.daysAuthorisedQty
              ? authForm?.daysAuthorisedQty
              : null,
            daysAuthorisedDayDelay: authForm?.daysAuthorisedDayDelay
              ? authForm?.daysAuthorisedDayDelay
              : null,
            treatmentIntensityLevel: null,
            sapAthEpdId: authForm?.sapAthEpdId,
            ext1StartDate: authForm?.ext1StartDate ? authForm?.ext1StartDate : null,
            ext1EndDate:
              moment(authForm?.ext1EndDate).format(formDateFormat) === 'Invalid date'
                ? null
                : moment(authForm?.ext1EndDate).format(formDateFormat),
            ext1DayQty: authForm?.ext1DayQty ? authForm?.ext1DayQty : null,
            ext2StartDate: authForm?.ext2StartDate ? authForm?.ext2StartDate : null,
            ext2EndDate:
              moment(authForm?.ext2EndDate).format(formDateFormat) === 'Invalid date'
                ? null
                : moment(authForm?.ext2EndDate).format(formDateFormat),
            ext2DayQty: authForm?.ext2DayQty ? authForm?.ext2DayQty : null,
            sapAthExt1IssueDate: authForm?.ext1IssueDate
              ? authForm?.ext1IssueDate
              : null,
            sapAthExt2IssueDate: authForm?.ext2IssueDate
              ? authForm?.ext2IssueDate
              : null,
            sapAthAdmSchYn: false,
            sapAthInactiveYn: false,
          };
          await postStopApi({ url, payload, authorization }).then((response) => {
            //console.log(response);
            if (response.succeeded === true) {
              fetchAuthList();
              fetchAuth(response.data.authId);

              const pdfUrl = `${EPISODE_AUTHORIZATION_PDF_URL}/${defaultValue.authId}`;
              const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
              dispatch(getAuthPdfForm({ pdfUrl, authorization }));
            }
          }).catch((e) => alert(e));
        } else {
          const payload = {
            authId: authForm?.authId,
            athIssueDate: authForm?.athIssueDate,
            athTPRcd: authForm?.athTPRcd,
            ath1502Rcd: authForm?.ath1502Rcd,
            reviewDate: authForm?.reviewDate ? authForm?.reviewDate : null,
            authStartDate: authForm?.authStartDate,
            modality: authForm?.modality?.id,
            CBPID: authForm?.communityBasedProvider?.id,
            budgetTypeId: authForm?.budgetType?.budTypeId,
            authType: authForm?.authType?.athTypId,
            fundingOrgId: authForm?.fundingOrg?.id,
            transferFormId: authForm?.transferForm?.id,
            initialReferralId: authForm?.initialReferral?.id
              ? authForm?.initialReferral?.id
              : null,
            authorizedByOriginalId: authForm?.authorizedByOriginal?.id,
            authorizedByExtension1Id: authForm?.authorizedByExtension1?.id,
            authorizedByExtension2Id: authForm?.authorizedByExtension2?.id,
            placementTypeId: authForm?.placementType?.id,
            relapse: authForm?.relapse?.id ? authForm?.relapse?.id.toString() : null,
            administrativeTransferAdmitId: authForm?.administrativeTransferAdmit?.id,
            authorizationReviewedBy: authForm?.authorizationReviewedBy?.id,
            cbpAuthEdited: user.contact.cntId,
            authEditDate: moment.utc().local().format("YYYY-MM-DDTHH:mm:ss"),
            authorizationCreatedBy: authForm?.authorizationCreatedBy?.id,
            authorizationCreatedDate: authForm?.authorizationCreatedDate,
            completionSurveyAdministered: authForm?.completionSurveyAdministered,
            authIsLocked: authForm?.authIsLocked,
            unitsTotal: authForm?.unitsTotal,
            authComment: authForm?.authComment,
            overallQty: authForm?.overallQty,
            overAllEndDate: moment(authForm?.overAllEndDate).format(formDateFormat),
            cbpAdmitDate: authForm?.cbpAdmitDate,
            cbpDischargeDate: authForm?.cbpDischargeDate,
            maxUnitsPerWeek: authForm?.maxUnitsPerWeek,
            maxIndsPerWeek: authForm?.maxIndsPerWeek,
            maxGrpsPerWeek: authForm?.maxGrpsPerWeek,
            daysAuthorisedQty: authForm?.daysAuthorisedQty,
            daysAuthorisedDayDelay: authForm?.daysAuthorisedDayDelay,
            treatmentIntensityLevel: null,
            sapAthEpdId: authForm?.sapAthEpdId,
            authEndDate:
              moment(authForm?.authEndDate).format(formDateFormat) === 'Invalid date'
                ? null
                : moment(authForm?.authEndDate).format(formDateFormat),
            ext1StartDate: authForm?.ext1StartDate,
            ext1EndDate:
              moment(authForm?.ext1EndDate).format(formDateFormat) === 'Invalid date'
                ? null
                : moment(authForm?.ext1EndDate).format(formDateFormat),
            ext1DayQty: authForm?.ext1DayQty,
            ext2StartDate: authForm?.ext2StartDate,
            ext2EndDate:
              moment(authForm?.ext2EndDate).format(formDateFormat) === 'Invalid date'
                ? null
                : moment(authForm?.ext2EndDate).format(formDateFormat),
            ext2DayQty: authForm?.ext2DayQty,
            sapAthExt1IssueDate: authForm?.ext1IssueDate,
            sapAthExt2IssueDate: authForm?.ext2IssueDate,
            sapAthAdmSchYn: false,
            sapAthInactiveYn: false,
          };
          await setStopApi({ url, payload, authorization }).then((response) => {
            if (response.succeeded === true) {
              fetchAuthList();

              const pdfUrl = `${EPISODE_AUTHORIZATION_PDF_URL}/${defaultValue.authId}`;
              const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
              dispatch(getAuthPdfForm({ pdfUrl, authorization }));
            }

            if (close) {
              setFormSuccess(true);
              setIsNewAuthForm(true);
              setOpen(false);
              dispatch(setModality(''));
              dispatch(setCommunityBasedProvider(''));
            }
          }).catch((e) => alert(e));
        }
      }
      catch (e) {
        console.log('error saving episode: ' + e.message)
      }
      finally {
        //setIsSubmitting(false);
      }
    //}
};

const handleNewCbpAuthForm = () => {
  const newCbpAuthFormData = {
    newCbpAuth: true,
    cboAthId: 0,
    dayQuantity: '',
    authStartDate: '',
    authEndDate: '',
  };
  dispatch(newCbpAuthForm(newCbpAuthFormData));
  setOpenCbpAuthDialog(true);
};

const handleOpenMakeAdjustment = () => {
  setOpenMakeAdjutmentDialog(true);
};

const cbpColumnsData = [
  { field: '_id', hide: true },
  {
    field: 'cboAthId',
    headerName: 'CBP Auth ID',
    sortable: false,
    flex: 1,
  },
  {
    field: 'authStartDate',
    headerName: 'Start Date',
    sortable: false,
    type: 'date',
    flex: 1,
  },
  {
    field: 'dayQuantity',
    headerName: 'Day Qty',
    sortable: false,
    flex: 1,
  },
  {
    field: 'authEndDate',
    headerName: 'End Date',
    sortable: false,
    type: 'date',
    flex: 1,
  },
];

const tmtColumnsData = [
  {
    field: 'tmtId',
    headerName: 'Tmt ID',
    sortable: false,
    flex: 1,
  },
  {
    field: 'tmtDate',
    headerName: 'Treatment Date',
    sortable: false,
    flex: 1,
    valueGetter: (params) => {
      if (!params.value) {
        return params.value;
      }
      return new Date(params.value).toLocaleDateString();
    },
  },
  {
    field: 'dte_WkID',
    headerName: 'Week Start',
    sortable: false,
    flex: 1,
    valueGetter: (params) => {
      if (!params.value) {
        return params.value;
      }
      return new Date(params.value).toLocaleDateString();
    },
  },
  {
    field: 'dte_MthID',
    headerName: 'Month',
    sortable: false,
    flex: 1,
  },
  {
    field: 'tmt_TmtTypId',
    headerName: 'Type',
    sortable: false,
    flex: 1,
  },
  {
    field: 'tmtStsDsc',
    headerName: 'Type',
    sortable: false,
    flex: 1,
  },
  {
    field: 'tmtAmt',
    headerName: 'Amount',
    sortable: false,
    flex: 1,
    valueGetter: (params) => {
      if (!params.value) {
        return params.value;
      }
      return params.value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      });
    },
  },
  {
    field: 'tmt_CboRteId',
    headerName: 'Rate ID',
    sortable: false,
    flex: 1,
  },
  {
    field: 'tmt_CboInvId',
    headerName: 'Invoice ID',
    sortable: false,
    flex: 1,
  },
  {
    field: 'tmtCredit_CboInvId',
    headerName: 'Credit Invoice ID',
    sortable: false,
    flex: 1,
  },
];

const authId = authForm?.authId;
  
  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            maxWidth: 'unset',
            width: '1000px',
            maxHeight: '90vh',
            '&::-webkit-scrollbar': { display: 'none' },
          },
        }}
      >
        {openBackdrop ? (
          <Backdrop
            sx={{zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openBackdrop}
          >
            <CircularProgress />
          </Backdrop>
        ) : (
          <>
            <DialogHeader>
              <Grid container style={{ padding: '5px'}}>
                <EpisodeHeader data={episodeHeaderData} />
                <Grid item xs={6}>
                  <DialogHeading variant='h5'>Authorization</DialogHeading>
                </Grid>
                <Grid item xs={6}>  
                <Grid container justifyContent="flex-end">
                  <Box>
                    <SaveButton
                      variant="contained"
                      //disabled={_.isEmpty(dirtyFields) || !isValid}
                      onClick={handleSubmit(onSubmit)}
                      disabled={formState.isSubmitting}
                    >
                      Save
                    </SaveButton>
                    &nbsp;&nbsp;
                    <Button variant="contained" disabled={!user?.contact?.authLock} onClick={handleOpenMakeAdjustment}>
                      Make Adjustment
                    </Button>
                    &nbsp;&nbsp;
                    <Button variant="contained" onClick={handlePrintAuth}>
                      Print View
                    </Button>
                    <IconButton onClick={handleClose}>
                      <CloseIcon />
                    </IconButton>
                  </Box>
                </Grid>
                </Grid>  
              </Grid>  

            </DialogHeader>
            <Box style={{ padding: '10px 20px' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <FormInputDropdown
                    name="modality"
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    options={authReferenceData?.modalityList}
                    errors={!!errors.modality}
                    helperText={errors?.modality?.message}
                    label="Modality"
                    modalityList={true}
                    register={register('modality', {
                      onChange: (e) => {
                        //onsole.log(e.target.value);
                        //dispatch(setModality(e.target.value));
                        //console.log(e.target.value);
                        //console.log(authReferenceData?.modalityList)
                        //const modId = authReferenceData?.modalityList.filter(m => m.modDsc==e.target.value)[0].modId;
                        //console.log(modId)
                        //console.log(authReferenceData?.communityBasedProviderList)
                        //setFilterProviderList(authReferenceData?.communityBasedProviderList.filter(c => c.value.includes(modId)));
                        //console.log(filterProviderList);
                      },
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={7}>
                  <FormInputDropdown
                    name="communityBasedProvider"
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    options={filterProviderList}
                    errors={!!errors.communityBasedProvider}
                    helperText={errors?.communityBasedProvider?.message}
                    label="Community Based Provider"
                    provider={true}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <FormInputText
                    name="budgetType"
                    type="text"
                    control={control}
                    disabled={true}
                    label="Budget Type"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <FormInputDropdown
                    name="fundingOrg"
                    control={control}
                    disabled={true}
                    options={authReferenceData?.fundingOrganizationList}
                    errors={!!errors.fundingOrg}
                    helperText={errors?.fundingOrg?.message}
                    label="Funding Organization"
                    defaultValue={
                      authReferenceData?.fundingOrganizationList[0].value
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormInputDropdown
                    name="authType"
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    options={authReferenceData?.authTypeList}
                    authTypeList={true}
                    errors={!!errors.authType}
                    helperText={errors?.authType?.message}
                    label="Auth Type"
                    defaultValue={
                      episodeReferralSource?.startsWith('NSG')
                        ? 'Non-Sap/Parole Referral'
                        : 'SAP Referral'
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormInputDropdown
                    name="placementType"
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    options={authReferenceData?.placementTypeList}
                    label="Placement Type"
                    errors={!!errors.placementType}
                    helperText={errors?.placementType?.message}
                  />
                  {/**
                  <FormInputDropdown
                    name='transferForm'
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    options={authReferenceData?.transferFormList}
                    label='Transfer from'
                  />
                  **/}
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography variant="h5" style={{ marginBottom: '10px' }}>
                    Authorization Details
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <FormInputText
                    name="athIssueDate"
                    type="date"
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    shrink={true}
                    label="Date Issued"
                    register={register('athIssueDate', {
                      onChange: (e) =>
                        dispatch(setAthIssueDate(e.target.value)),
                    })}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormInputDropdown
                    name="authorizedByOriginal"
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    options={authReferenceData?.authorizedByOriginal}
                    label="Authorized By"
                    errors={!!errors.authorizedByOriginal}
                    helperText={errors?.authType?.message}
                  />
                </Grid>
                <Grid item xs={2}>
                  <FormInputText
                    name="authStartDate"
                    type="date"
                    control={control}
                    shrink={true}
                    disabled={defaultValue.authIsLocked}
                    errors={!!errors.authStartDate}
                    helperText={errors?.authStartDate?.message}
                    label="Authorized Auth Start"
                    register={register('authStartDate', {
                      onChange: (e) => {
                        dispatch(setAuthStartDate(e.target.value));
                      },
                    })}
                  />
                </Grid>
                <Grid item xs={1}>
                  <FormInputText
                    name="daysAuthorisedQty"
                    //type='number'
                    control={control}
                    minValue={0}
                    shrink={true}
                    disabled={defaultValue.authIsLocked}
                    errors={!!errors.daysAuthorisedQty}
                    helperText={errors?.daysAuthorisedQty?.message}
                    label="Qty"
                    register={register('daysAuthorisedQty', {
                     onChange: (e) => {
                       dispatch(
                         setDaysAuthorisedQty(
                           e.target.value
                             ? Number.parseInt(e.target.value)
                             : ''
                         )
                       )},
                    })}
                    // onChange={(e) => {
                    //   console.log(e)
                    //   dispatch(
                    //     setDaysAuthorisedQty(
                    //       e.target.value
                    //         ? Number.parseInt(e.target.value)
                    //         : ''
                    //     )
                    //   )
                    // }}
                  />
                </Grid>
                <Grid item xs={1}>
                  <FormInputText
                    name="daysAuthorisedDayDelay"
                    //type='number'
                    control={control}
                    shrink={true}
                    minValue={0}
                    disabled={defaultValue.authIsLocked}
                    label="Delay"
                    register={register('daysAuthorisedDayDelay', {
                      onChange: (e) =>
                        dispatch(
                          setDaysAuthorisedDayDelay(
                            Number.parseInt(e.target.value)
                          )
                        ),
                    })}
                  />
                </Grid>
                <Grid item xs={2}>
                  <FormInputText
                    name="authEndDate"
                    type="date"
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    minValue={defaultValue?.authStartDate}
                    shrink={true}
                    label="Authorized Auth End"
                    register={register('authEndDate', {
                      onChange: (e) => dispatch(setAuthEndDate(e.target.value)),
                    })}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={1} mt={-2}>
                <Grid item xs={6}>
                  <Typography textAlign="right">Overall:</Typography>
                </Grid>
                <Grid item xs={2}>
                  <FormInputText
                    name="overAllStartDate"
                    control={control}
                    type="date"
                    disabled={true}
                    shrink={true}
                    label="Start"
                  />
                </Grid>
                <Grid item xs={1}>
                  <FormInputText
                    name="overallQty"
                    control={control}
                    disabled={true}
                    shrink={true}
                    label="Qty"
                  />
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={2}>
                  <FormInputText
                    name="overAllEndDate"
                    control={control}
                    type="date"
                    disabled={true}
                    shrink={true}
                    label="End"
                  />
                </Grid>

                {/**                
                <Grid item xs={12} sm={4}>
                  <Typography variant='h5' style={{ marginBottom: '10px' }}>
                    Extension 1 :
                  </Typography>
                  <FormInputText
                    name='ext1IssueDate'
                    type='date'
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    shrink={true}
                    label='Date Issued'
                    register={register('ext1IssueDate', {
                      onChange: (e) =>
                        dispatch(setExt1IssueDate(e.target.value)),
                    })}
                  />
                  <FormInputDropdown
                    name='authorizedByExtension1'
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    options={authReferenceData?.authorizedByExtension1}
                    label='Authorized By'
                  />
                  <FormInputText
                    name='ext1StartDate'
                    type='date'
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    shrink={true}
                    label='Days Authorized Auth Start'
                    register={register('ext1StartDate', {
                      onChange: (e) =>
                        dispatch(setExt1StartDate(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='ext1DayQty'
                    type='number'
                    minValue={0}
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    label='Days Authorized Qty'
                    register={register('ext1DayQty', {
                      onChange: (e) =>
                        dispatch(
                          setExt1DayQty(Number.parseInt(e.target.value))
                        ),
                    })}
                  />
                  <FormInputText
                    name='delay'
                    type='number'
                    minValue={0}
                    control={control}
                    disabled={true}
                    label='Days Authorized Delay'
                    // register={register('dateReferralSentFromSAP', {
                    //   onChange: (e) =>
                    //     dispatch(setDateReferralSentFromSAP(e.target.value)),
                    // })}
                  />
                  <FormInputText
                    name='ext1EndDate'
                    type='date'
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    minValue={defaultValue?.authStartDate}
                    shrink={true}
                    label='Days Authorized Auth End'
                    register={register('ext1EndDate', {
                      onChange: (e) => dispatch(setExt1EndDate(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='overallQty'
                    control={control}
                    type='text'
                    disabled={true}
                    label='Overall Qty'
                    // register={register('overallQty', {
                    //   onChange: (e) => dispatch(setOverallQty(e.target.value)),
                    // })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant='h5' style={{ marginBottom: '10px' }}>
                    Extension 2 :
                  </Typography>
                  <FormInputText
                    name='ext2IssueDate'
                    type='date'
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    shrink={true}
                    label='Date Issued'
                    register={register('ext2IssueDate', {
                      onChange: (e) =>
                        dispatch(setExt2IssueDate(e.target.value)),
                    })}
                  />
                  <FormInputDropdown
                    name='authorizedByExtension2'
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    options={authReferenceData?.authorizedByExtension2}
                    label='Authorized By'
                  />
                  <FormInputText
                    name='ext2StartDate'
                    type='date'
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    shrink={true}
                    label='Days Authorized Auth Start'
                    register={register('ext2StartDate', {
                      onChange: (e) =>
                        dispatch(setExt2StartDate(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='ext2DayQty'
                    type='number'
                    minValue={0}
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    label='Days Authorized Qty'
                    register={register('ext2DayQty', {
                      onChange: (e) =>
                        dispatch(
                          setExt2DayQty(Number.parseInt(e.target.value))
                        ),
                    })}
                  />
                  <FormInputText
                    name='delay'
                    type='number'
                    minValue={0}
                    control={control}
                    disabled={true}
                    label='Days Authorized Delay'
                    // register={register('dateReferralSentFromSAP', {
                    //   onChange: (e) =>
                    //     dispatch(setDateReferralSentFromSAP(e.target.value)),
                    // })}
                  />
                  <FormInputText
                    name='ext2EndDate'
                    type='date'
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    minValue={defaultValue?.authStartDate}
                    shrink={true}
                    label='Days Authorized Auth End'
                    register={register('ext2EndDate', {
                      onChange: (e) => dispatch(setExt2EndDate(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='overAllEndDate'
                    control={control}
                    type='date'
                    shrink={true}
                    disabled={true}
                    label='Overall Auth End'
                    // register={register('overAllEndDate', {
                    //   onChange: (e) =>
                    //     dispatch(setOverAllEndDate(e.target.value)),
                    // })}
                  />
                </Grid>
                **/}
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <FormInputText
                    name="unitsTotal"
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    type="number"
                    minValue={0}
                    label="Units Total"
                    register={register('unitsTotal', {
                      onChange: (e) =>
                        dispatch(
                          setUnitsTotal(Number.parseInt(e.target.value))
                        ),
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormInputText
                    name="maxUnitsPerWeek"
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    type="number"
                    minValue={0}
                    label="Weekly Units Max"
                    register={register('maxUnitsPerWeek', {
                      onChange: (e) =>
                        dispatch(
                          setMaxUnitsPerWeek(Number.parseInt(e.target.value))
                        ),
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormInputText
                    name="maxIndsPerWeek"
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    type="number"
                    minValue={0}
                    label="Weekly Units Ind"
                    register={register('maxIndsPerWeek', {
                      onChange: (e) =>
                        dispatch(
                          setMaxIndsPerWeek(Number.parseInt(e.target.value))
                        ),
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormInputText
                    name="maxGrpsPerWeek"
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    type="number"
                    minValue={0}
                    label="Weekly Units Grp"
                    register={register('maxGrpsPerWeek', {
                      onChange: (e) =>
                        dispatch(
                          setMaxGrpsPerWeek(Number.parseInt(e.target.value))
                        ),
                    })}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <FormInputText
                    name="cbpAdmitDate"
                    type="date"
                    control={control}
                    disabled= {true} //{defaultValue.authIsLocked}
                    shrink={true}
                    label="CBP Admit"
                    register={register('cbpAdmitDate', {
                      onChange: (e) =>
                        dispatch(setCbpAdmitDate(e.target.value)),
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  { authForm?.cbpAdmitDate &&
                    <Button                    
                      variant="contained"
                      onClick={() => setIsCalOMSAdmitForm(true)}
                    >
                      CalOMS Admit
                    </Button>
                  }  
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormInputText
                    name="cbpDischargeDate"
                    type="date"
                    control={control}
                    shrink={true}
                    disabled={true} //{defaultValue.authIsLocked}
                    label="CBP Discharge"
                    register={register('cbpDischargeDate', {
                      onChange: (e) =>
                        dispatch(setCbpDischargeDate(e.target.value)),
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  { authForm?.cbpDischargeDate &&
                    <Button
                      variant="contained"
                      onClick={() => setIsCalOMSDischargeForm(true)}
                    >
                      CalOMS Discharge
                    </Button>
                  }  
                </Grid>
                <Grid item xs={12} sm={6}>
                  {/**
                  <FormInputDropdown
                    name='relapse'
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    options={authReferenceData?.relapseList}
                    label='Relapse'
                  />
                  **/}
                  <Grid item xs={12} sm={6}></Grid>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="firstTmt"
                    //type="date"
                    //control={control}
                    disabled={true}
                    shrink={true}
                    label="First Treatement Verified"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={treatments.length > 0 ? moment(treatments[treatments.length-1].tmtDate).format(dateFormat2) : ''}
                    // register={register('cbpDischargeDate', {
                    //   onChange: (e) =>
                    //     dispatch(setAuthStartDate(e.target.value)),
                    // })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="lastTmt"
                    //type="date"
                    //control={control}
                    disabled={true}
                    shrink={true}
                    label="Last Treatement Verified"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={treatments.length > 0 ? moment(treatments[0].tmtDate).format(dateFormat2) : ''}
                    // register={register('cbpDischargeDate', {
                    //   onChange: (e) =>
                    //     dispatch(setAuthStartDate(e.target.value)),
                    // })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormInputDropdown
                    name="authorizationReviewedBy"
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    options={authReferenceData?.authReviewedByList}
                    label="Authorization Reviewed By"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormInputText
                    name="reviewDate"
                    type="date"
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    shrink={true}
                    label="Review Date"
                    register={register('reviewDate', {
                      onChange: (e) => dispatch(setReviewDate(e.target.value)),
                    })}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FormInputMultiCheckbox
                    control={control}
                    name="authIsLocked"
                    label="Auth is locked"
                    checked={defaultValue.authIsLocked}
                    disabled={!user?.contact?.authLock}
                    register={register('authIsLocked', {
                      onChange: (e) => {
                        dispatch(
                          setAuthIsLocked({
                            value: e.target.value,
                            user: {
                              id: user.contact.cntId,
                              value: user.contact.cntKey,
                            },
                          })
                        );
                        if (e.target.value) {
                          //console.log(new Date(moment().format().split('T')[0] + 'T00:00'));
                          dispatch(setReviewDate(new Date(moment().format().split('T')[0] + 'T00:00')));
                          dispatch(
                            setAuthorizationReviewedBy({
                              id: user.contact.cntId,
                              value: user.contact.cntKey,
                            })
                          );
                        }
                      },
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormInputText
                    name="athTPRcd"
                    type="date"
                    control={control}
                    //disabled={defaultValue.authIsLocked}
                    shrink={true}
                    label="Treatment Plan Received"
                    register={register('athTPRcd', {
                      onChange: (e) => dispatch(setAthTPRcd(e.target.value)),
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormInputText
                    name="ath1502Rcd"
                    type="date"
                    control={control}
                    //disabled={defaultValue.authIsLocked}
                    shrink={true}
                    label="1502 Received"
                    register={register('ath1502Rcd', {
                      onChange: (e) => dispatch(setAth1502Rcd(e.target.value)),
                    })}
                  />
                </Grid>

                {/**
                <Grid item xs={12} sm={6}>
                  <FormInputText
                    name='authComment'
                    type='text'
                    control={control}
                    multiline={true}
                    disabled={defaultValue.authIsLocked}
                    rows={3.5}
                    errors={!!errors.authComment}
                    helperText={errors?.authComment?.message}
                    label='Clinical Info/Auth Comment'
                    register={register('authComment', {
                      onChange: (e) => dispatch(setAuthComment(e.target.value)),
                    })}
                  />
                </Grid>
                **/}
              </Grid>
              {/**
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormInputMultiCheckbox
                    control={control}
                    name='completionSurveyAdministered'
                    label='Completion Survey Administered'
                    checked={defaultValue.completionSurveyAdministered}
                    register={register('completionSurveyAdministered', {
                      onChange: (e) =>
                        dispatch(
                          setCompletionSurveyAdministered(e.target.value)
                        ),
                    })}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <FormInputDropdown
                    name='administrativeTransferAdmit'
                    control={control}
                    options={authReferenceData?.admTransferAdmitList}
                    disabled={defaultValue.authIsLocked}
                    label='Administrative Transfer'
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormInputDropdown
                    name='authorizationReviewedBy'
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    options={authReferenceData?.authReviewedByList}
                    label='Authorization Reviewed By'
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormInputText
                    name='reviewDate'
                    type='date'
                    control={control}
                    disabled={defaultValue.authIsLocked}
                    shrink={true}
                    label='Review Date'
                    register={register('reviewDate', {
                      onChange: (e) => dispatch(setReviewDate(e.target.value)),
                    })}
                  />
                </Grid>
              </Grid>
              **/}
              <ButtonWrapper>
                <CancelButton
                  variant="contained"
                  //disabled={_.isEmpty(dirtyFields) || !isValid}
                  onClick={handleClose}
                >
                  Cancel
                </CancelButton>
                {cbpData?.data?.length == 0 && authForm?.authId != 0 && (
                  <DeleteButton
                    variant="contained"
                    disabled={defaultValue.authIsLocked}
                    onClick={handleDelete}
                  >
                    Delete
                  </DeleteButton>
                )}
                <SaveButton
                  variant="contained"
                  //disabled={_.isEmpty(dirtyFields) || !isValid}
                  disabled={formState.isSubmitting}
                  onClick={handleSubmit(onSubmit)}
                >
                  Save
                </SaveButton>
              </ButtonWrapper>
              <Grid container style={{ padding: '20px', color: 'blue' }}>
                <Grid item xs={12}>
                  Created By : {authForm?.authorizationCreatedBy?.value} on{' '}
                  {moment(authForm?.authorizationCreatedDate)
                    //.utc(authForm?.authorizationCreatedDate)
                    //.local()
                    .format(dateTimeFormat)}{' '}
                  | Edited By :{' '}
                  {authForm?.cbpAuthEditedBy
                    ? authForm?.cbpAuthEditedBy?.value
                    : authForm?.authorizationCreatedBy?.value}{' '}
                  on{' '}
                  {moment(authForm?.authEditDate)
                    //.utc(authForm?.authEditDate)
                    //.local()
                    .format(dateTimeFormat)}
                </Grid>
              </Grid>
            </Box>

            {authForm?.newAuthForm ? (
              ''
            ) : (
              <>
                <DialogDivider variant="middle" />
                <Grid container style={{ padding: '0px 40px' }}>
                  <GridContainer container>
                    <Grid item xs={6}>
                      <NoteHeading variant="h5">
                        To edit cbp auth please click on a row
                      </NoteHeading>
                    </Grid>
                    <LeftGrid item xs={6}>
                      <Button
                        disabled={!defaultValue.authIsLocked || cbpData?.data?.length > 0}
                        variant="contained"
                        onClick={() => handleNewCbpAuthForm()}
                      >
                        New CBP Authorization
                      </Button>
                    </LeftGrid>
                  </GridContainer>
                  <Grid item xs={12}>
                    <DataGridContainer>
                      <DataGrid
                        getRowHeight={() => 'auto'}
                        columns={cbpColumnsData}
                        rows={cbpData.data}
                        rowCount={cbpData.total}
                        getRowId={(row) => row._id}
                        rowsPerPageOptions={[10, 25, 50]}
                        pageSize={cbpData.pageSize}
                        pagination
                        paginationMode="server"
                        getRowClassName={(params) =>
                          params.indexRelativeToCurrentPage % 2 === 0
                            ? 'even'
                            : 'odd'
                        }
                        // onPageSizeChange={(newPageSize) =>
                        //   setCbpData((prveState) => ({
                        //     ...prveState,
                        //     pageSize: newPageSize,
                        //   }))
                        // }
                        // onPageChange={(newPage) => {
                        //   setCbpData((prveState) => ({
                        //     ...prveState,
                        //     page: newPage + 1,
                        //   }));
                        // }}
                        loading={cbpData.isLoading}
                        onRowClick={(param) => cbpAuthRowClick(param.row)}
                        disableColumnFilter
                        disableColumnMenu
                      />
                    </DataGridContainer>
                  </Grid>
                  <Grid item xs={12}>
                    <DataGridContainer>
                      <DataGrid
                        getRowHeight={() => 'auto'}
                        columns={tmtColumnsData}
                        rows={treatments}
                        getRowId={(row) => row.tmtId}
                        getRowClassName={(params) =>
                          params.indexRelativeToCurrentPage % 2 === 0
                            ? 'even'
                            : 'odd'
                        }
                        disableColumnFilter
                        disableColumnMenu
                      />
                    </DataGridContainer>
                  </Grid>
                </Grid>
              </>
            )}
          </>
        )}
      </Dialog>
      <CbpAuthDialog
        open={openCbpAuthDialog}
        setOpen={setOpenCbpAuthDialog}
        setCloseAuthDialog={setOpen}
        authToken={authToken}
        // episodeId={episodeId}
        openCbpBackdrop={openCbpBackdrop}
        fetchAuth={fetchAuth}
        loggedInContact={user?.contact}
        treatments={treatments}
        startDate={defaultValue?.authStartDate}
        //fetchAuthRow={fetchAuthRow}
      />
      <AuthPdfDialog
        open={openAuthPdfDialog}
        setOpen={setOpenAuthPdfDialog}
        openCbpAuthPdfBackdrop={openAuthPdfBackdrop}
        authData={authData}
      />
      <FormSuccess
        formSuccess={formSuccess}
        setFormSuccess={setFormSuccess}
        isNewForm={isNewAuthForm}
      />
      <CalOMSAdmit
        open={isCalOMSAdmitForm}
        setOpen={setIsCalOMSAdmitForm}
        authId={authId}
      />
      <CalOMSDischarge
        open={isCalOMSDischargeForm}
        setOpen={setIsCalOMSDischargeForm}
        authId={authId}
      />
      <MakeAdjustmentDialog
        open={openMakeAdjutmentDialog}
        setOpen={setOpenMakeAdjutmentDialog}
        cbpList={filterProviderList}
        authId={authId}
        setAuthOpen={setOpen}
        fetchAuthList={fetchAuthList}
        cntId={user?.contact?.cntId}
        oldDayQty={daysAuthorisedQty}
        sapOrgId={authReferenceData?.fundingOrganizationList[0].id}
        authToken={authToken}
      />
    </>
  );
};

export default AuthDialog;
